import { useGetComponentsQuery, ComponentInfoFragment } from 'gqlTypes'

// This is a valid use case to narrow down Component type
// eslint-disable-next-line no-restricted-imports
import { Symbol as SymbolComponent } from 'gqlTypes/expansiveTypes'

import { useGetIdentifiers } from './useGetIdentifiers'

const isSymbolComponent = (
  component?: ComponentInfoFragment
): component is SymbolComponent => component?.__typename === 'Symbol'

export const useGetSymbols = (search?: string) => {
  const { shareIdentifier, versionShortId } = useGetIdentifiers()
  const { loading, data, refetch, fetchMore } = useGetComponentsQuery({
    variables: {
      shareIdentifier,
      versionShortId,
      type: 'SYMBOL',
      search,
    },
  })

  return {
    loading,
    filter: (path: string | null) => refetch({ path }),
    fetchMore,
    entries:
      data?.share?.version?.document?.components.entries.filter(
        isSymbolComponent
      ) || [],
    meta: data?.share?.version?.document?.components.meta,
  }
}
